import { useLayoutEffect } from "react";
export function useClientLayoutEffect() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    if (typeof document === "undefined") return;
    // eslint-disable-next-line react-hooks/rules-of-hooks, react-hooks/exhaustive-deps
    useLayoutEffect(...args);
}
